export default __webpack_public_path__ + "static/media/dds_logo.cf19975f.png";